import React from 'react'

export const parseContent = (content: string): React.ReactNode => {
  const paragraphs = content.split('\n')

  return paragraphs.map((paragraph, index) => (
    <p key={`paragraph-${index}`} className="mb-2 text-foreground text-xl">
      {paragraph}
    </p>
  ))
}

const exporter = { parseContent }

export default exporter
